import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
  
  export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if(loading) {
        return <div>Loading...</div>
    }

    if(user) {
        return children;
    }
   
    return <Navigate to="/login" replace />;
  };